/**
 * Split out of the engine section: the rules deserve their own dark cut
 * rather than a panel tucked under the flow diagram.
 */
const REGS = [
  { change: 'FAR Part 12 rewritten under the overhaul · effective', effect: '3 programs affected', amber: true },
  { change: 'Class deviation · commercial solutions opening thresholds', effect: '1 pathway re-ranked', amber: true },
  { change: 'Agency supplement · clause matrix updated', effect: 'No action needed', amber: false },
]

export default function Regulations() {
  return (
    <section id="regulations" className="lp-sec lp-sec--dark">
      <div className="lp-wrap lp-two lp-regs">
        <div style={{ minWidth: 0 }}>
          <div className="lp-eyebrow">THE RULES, KEPT CURRENT</div>
          <h2 className="lp-h2">
            The regulations change. Your program already knows.
          </h2>
          <p>
            Versioned, dated regulations with change monitoring. Pathway logic,
            clause matrices, and drafts reflect what is in effect today, and your
            team is told what moved and which programs it touches.
          </p>
        </div>

        <div className="lp-panel lp-panel--dark">
          <div className="lp-panel__label">REGULATORY CHANGES · THIS WEEK</div>
          {REGS.map((r) => (
            <div
              key={r.change}
              className={`lp-panel__row lp-panel__row--wide${r.amber ? ' lp-panel__amber' : ''}`}
            >
              <span>{r.change}</span>
              <span>{r.effect}</span>
            </div>
          ))}
          <div className="lp-panel__foot">
            Every citation in a draft points at the version in effect on the date
            it was written.
          </div>
        </div>
      </div>
    </section>
  )
}
